

import React, { useState } from "react";
import {
  Grid,
  Button,
  Box,
  Typography,
  Paper,
  LinearProgress,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FiUpload } from "react-icons/fi";
import { HiDocumentArrowUp } from "react-icons/hi2";
import { RiDeleteBin2Line } from "react-icons/ri";
import { FaEye } from "react-icons/fa6";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useDispatch } from "react-redux";
import actions from "../../ReduxStore/actions";
import { adminUrl } from "../../constants";
// import { useDispatch } from "react-redux";
// import actions from "../../ReduxStore/actions";
// import { adminUrl } from "../../constants";

const FileUploadComponent = ({
  name,
  onFileUpload,
  uploadedFile,
  setUploadedFile,
  selectedDocumentType,
}) => {
  const [openPreview, setOpenPreview] = useState(false);
  console.log(uploadedFile, "uploadedFile")
  const dispatch = useDispatch();
  console.log(uploadedFile,"uploaded filee")

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("uploadFile", file);

      const data1 = {
        data: formData,
        method: "post",
        apiName: "uploadPdfAndImage",
      };

      const response = await dispatch(actions.UPLOADPDFANDIMAGE(data1));

      if (response.payload?.data?.fileUrl) {
        const fileUrl = response.payload.data.fileUrl;
        const fileType = selectedDocumentType ? selectedDocumentType.type : file.type;

        setUploadedFile({ fileUrl, type: fileType, progress: 100 });
        onFileUpload(fileUrl);
      }
      
    }
  };

  // const handleFileUpload = async (event) => {
  //   const file = event.target.files[0];
  //   console.log("workkkk")

  //   if (file) {
  //     const fileType = file.type.includes("image") ? "image" : "pdf";
  //     console.log(fileType, "fileType")
  //     console.log("workkkk11")

  //     const fileUrl = URL.createObjectURL(file); // Create a temporary URL for preview

  //     setUploadedFile({ fileUrl, type: fileType, progress: 100 });
  //     onFileUpload(fileUrl);
  //   }
  // };


  const handleFileDelete = () => {
    setUploadedFile(null);
    onFileUpload(null);
  };

  return (
    <Grid>
      <label htmlFor={`file-upload-${name}`} style={{ fontSize: "16px", paddingBottom: "10px" }}>
        Select File{" "}
        <span style={{ fontSize: "11px", color: "#7A7A7A" }}>(Supported: .png, .jpg, .pdf)</span>
      </label>

      <input
        accept=".png,.jpg,.pdf"
        style={{ display: "none" }}
        id={`file-upload-${name}`}
        type="file"
        name={name}
        onChange={handleFileUpload}
      />

      <label htmlFor={`file-upload-${name}`} style={{ marginTop: "10px" }}>
        <Button
          component="span"
          startIcon={<FiUpload style={{ fontSize: "14px" }} />}
          sx={{
            width: "100%",
            color: "white",
            background: "var(--main-color)",
            borderRadius: "3px",
            fontSize: "14px",
            textTransform: "none",
            height: "35px",
            marginTop: "3px"
          }}
        >
          Browse
        </Button>
      </label>

      {uploadedFile && (
        <Grid item xs={12} mt={2}>
          <Paper
            elevation={3}
            sx={{
              padding: "5px",
              background: "#F7F7F7",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <HiDocumentArrowUp style={{ fontSize: "30px", color: "var(--main-color)", marginRight: "10px" }} />
            </Box>

            <Box sx={{ width: "100%" }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="body1" sx={{ fontSize: "12px" }}>
                  {uploadedFile?.type}
                </Typography>
                <Box>
                  <IconButton onClick={() => setOpenPreview(true)} sx={{ color: "black" }}>
                    <FaEye style={{ fontSize: "14px" }} />
                  </IconButton>
                  <IconButton
                    onClick={handleFileDelete}
                    sx={{
                      color: "black",
                      "&:hover": { color: "red" },
                    }}
                  >
                    <RiDeleteBin2Line style={{ fontSize: "14px" }} />
                  </IconButton>
                </Box>
              </Box>

              <LinearProgress
                variant="determinate"
                value={uploadedFile.progress}
                sx={{
                  height: "6px",
                  borderRadius: "10px",
                  backgroundColor: "lightgray",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: uploadedFile.progress === 100 ? "#1FC45B" : "red",
                  },
                }}
              />

              <Box display="flex" justifyContent="end">
                <Typography
                  variant="body1"
                  fontSize="12px"
                  color={uploadedFile.progress === 100 ? "green" : "red"}
                >
                  {uploadedFile.progress === 100 ? "Upload Successful!" : `${uploadedFile.progress}%`}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      )}

      {/* Preview Dialog */}
      <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="subtitle1">Preview</Typography>
          <IconButton
            onClick={() => setOpenPreview(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <IoMdCloseCircleOutline />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

          {uploadedFile?.fileUrl && uploadedFile?.type.startsWith("image/") ? (
            <img
              src={`${adminUrl}${uploadedFile?.fileUrl}`}
              alt="Preview"
              style={{ maxWidth: "100%", maxHeight: "500px", objectFit: "contain" }}
            />
          ) : (
            <iframe
              src={`${adminUrl}${uploadedFile?.fileUrl}`}
              title="PDF Preview"
              width="100%"
              height="500px"
              style={{ border: "none" }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default FileUploadComponent;
